import * as React from 'react';
function SvgAnimal(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <defs>
        <style />
      </defs>
      <g id="Animal_svg__Layer_2" data-name="Layer 2">
        <path
          d="M10.47 11.5a1 1 0 01-1-1V10a1 1 0 012 0v.5a1 1 0 01-1 1zM21 21.07c.36-5.07-.75-15.56-7.55-19a1 1 0 00-1 0A1 1 0 0012 3v2.51c-2.08.09-5.39.61-5.92 4h-.61a1.19 1.19 0 00-.32.05A3.17 3.17 0 003 12.5a4.36 4.36 0 002.55 3.89 6.62 6.62 0 002.28.61c1 .14 1.38.21 1.74.94a5.7 5.7 0 01-.42 2.5 1 1 0 001.53 1.27c.44-.44 1.35-3.33.69-4.66a3.65 3.65 0 00-3.29-2 4.82 4.82 0 01-1.66-.41A2.43 2.43 0 015 12.5a1.15 1.15 0 01.7-1H7a1 1 0 001-1c0-2.5 1.91-3 5-3a1 1 0 001-1V4.82c4.56 3.65 5.3 11.91 5 16.11a1 1 0 00.9 1.07h.1a1 1 0 001-.93z"
          id="Animal_svg__Layer_1-2"
          data-name="Layer 1"
        />
      </g>
    </svg>
  );
}
export default SvgAnimal;
